import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import { ButtonWithIcon } from '@els/els-react--button';

import './SubstanceMoreNamesInformation.scss';

function SubstanceMoreNamesInformation({ onToggle, substance }) {
  const { details } = substance;
  const { chemicalNames, chemicalNameSynonyms } = details;

  const firstName = chemicalNames[0];
  const otherNames = chemicalNameSynonyms.join('; ');

  return (
    <div
      id="substance-supplier-information"
      className="substance-results-information u-els-background-color-n0 u-els-margin-top u-els-padding u-els-font-size-base u-els-line-height-default"
      aria-expanded>
      <div className="sub-menu">
        <div className="more-names-header">
          <h3>Chemical Names and Synonyms</h3>
          <ButtonWithIcon data-e2e="more-names-close" type="link" iconOnly sprite="Close" tabIndex="0" role="button" onClick={onToggle}>
            close
          </ButtonWithIcon>
        </div>

        <InnerHTML tag="div" html={firstName} mode="escape" />
        <InnerHTML tag="div" className="rx-substance-identification u-els-margin-top-1o4" html={otherNames} mode="escape" />
      </div>
    </div>
  );
}

SubstanceMoreNamesInformation.propTypes = {
  onToggle: PropTypes.func.isRequired,
  substance: PropTypes.object.isRequired,
};

export default SubstanceMoreNamesInformation;
